import getCookie, { COOKIE_MH_TOKEN } from '../../../common/cookies';
import environment from '../../../common/environment';
import { getResponseData } from '../../../common/utils/api-utils';
import { OptinOutData } from '../interface/inclusive-access.interface';

export async function getInclusiveAccessApiCall(): Promise<OptinOutData[]> {
  const token = getCookie(COOKIE_MH_TOKEN);
  const url = new URL(`${environment().inclusiveAccessUrl}`);
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
  );
}

export async function updateInclusiveAccessApiCall(data): Promise<OptinOutData[]> {
  const token = getCookie(COOKIE_MH_TOKEN);
  const url = new URL(`${environment().optInOutUrl}`);
  return await getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data)
    })
  );
}
